import { useEffect, useMemo, useRef } from 'react'

import mixpanel from 'mixpanel-browser'

import { useSplitEnabled } from '@buffer-mono/features'

import { isRealProduction } from '~publish/env'
import { logError } from '~publish/legacy/utils/logError'

/**
 * Hook to start/stop Mixpanel session recording when user visits CommunityPage.
 * Requires Mixpanel to be initialized globally via useMixpanelSessionReplay hook.
 */
export function useMixpanelCommunityRecording(): void {
  const isRecordingRef = useRef(false)
  const isProduction = useMemo(() => isRealProduction(), [])
  const { isEnabled: isMixpanelReplaysEnabled } = useSplitEnabled(
    'geid-cet-mixpanel-replays',
  )

  useEffect(() => {
    try {
      const shouldRecord = isProduction && isMixpanelReplaysEnabled

      if (shouldRecord && !isRecordingRef.current) {
        // Register commit hash as a super property
        // This will be sent with all events in this session
        // mixpanel.register({
        //   app_version: env.VITE_COMMIT_HASH,
        //   recording_context: 'community_page',
        // })

        mixpanel.start_session_recording()
        isRecordingRef.current = true
      }

      // return (): void => {
      //   if (isRecordingRef.current) {
      //     mixpanel.stop_session_recording()
      //     // Unregister the recording context so it doesn't persist to other sessions
      //     mixpanel.unregister('recording_context')
      //     isRecordingRef.current = false
      //   }
      // }
    } catch (error) {
      logError(error, { context: 'manageMixpanelCommunityRecording' })
      isRecordingRef.current = false
    }
  }, [isMixpanelReplaysEnabled, isProduction])
}
